import React, { useRef, useState, useEffect } from "react";
import collaborationStyle from "./collaboration-modal-new.module.css";
import style from "./new-collaboration-modal.module.css";
import CollaborationHeaderNew from "./collaboration-header-new";
import { InstanceType } from "shared/datamodel/schemas/ability";

// Helper function to check if name is empty or only whitespace
const isNameValid = (name: string): boolean => {
  return name.trim().length > 0;
};

export default function RenameModal({
  currentName,
  type,
  onDismiss,
  onEditName,
}: {
  currentName: string;
  type: InstanceType;
  onDismiss: () => void;
  onEditName: (name: string) => void;
}) {
  const [name, setName] = useState<string>(currentName);

  const modalRef = useRef(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.select();
    }
  }, []);

  const typeName = type === InstanceType.Board ? "canvas" : type;

  return (
    <div className={collaborationStyle.container} ref={modalRef}>
      <CollaborationHeaderNew title={`Rename`} subtitle={`Enter a new name for your ${type}`} onDismiss={onDismiss} />
      <div className={style.inviteField}>
        <form
          className={collaborationStyle.nameInput}
          onSubmit={(e) => {
            e.preventDefault();
            if (isNameValid(name)) {
              onEditName(name);
              onDismiss();
            }
          }}
        >
          <input
            ref={inputRef}
            onChange={(e) => setName(e.target.value)}
            value={name}
            placeholder={`${typeName} name`}
            autoFocus={true}
            autoComplete="off"
            data-testid="rename-input"
          />
        </form>
        <div className={style.buttonsContainer}>
          <button
            className={style.cancelCollaborationButton}
            disabled={!isNameValid(name)}
            onClick={() => {
              onDismiss();
            }}
            style={{ width: 95 }}
          >{`Cancel`}</button>
          <button
            className={style.createCollaborationButton}
            disabled={!isNameValid(name)}
            onClick={() => {
              onEditName(name);
              onDismiss();
            }}
            style={{ width: 95 }}
          >{`Ok`}</button>
        </div>
      </div>
    </div>
  );
}
